import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from "./logo.png";

const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt
        glareEnable={true}
        glareMaxOpacity={0.25}
        scale={1.03}
        tiltMaxAngleX={8}
        tiltMaxAngleY={8}
      >
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
        <div className="card-face card-front">
  <div className="row h-100">

    {/* Left Side */}
    <div className="col-7 d-flex flex-column justify-content-between">

      {/* Logo */}
      <div>
        <div
          className=" d-inline-block"
          style={{
            width: "120px",
            marginTop: "10px"
          }}
        >
          <img
            src={logo}
            className="img-fluid"
            alt="Company Logo"
          />
        </div>
      </div>

      {/* Name */}
      <div className="pb-3">
        <h3
          style={{
            fontSize: "26px",
            fontWeight: "400",
            letterSpacing: "1px",
            marginBottom: "0",
            textTransform: "uppercase",
            color: "#111"
          }}
        >
          MR. RAJESH GOYAL
        </h3>

        <p
          style={{
            fontSize: "18px",
            color: "#333",
            margin: "0"
          }}
        >
          Director
        </p>
      </div>

    </div>

    {/* Right Side */}
    <div className="col-5 text-end pt-3">

       <p className="card-phone mb-2">
                  <i className="fa fa-phone "></i>
                  +91-9311280682
                </p>

                <p className="card-phone mb-2">
                  <i className="fa fa-phone "></i>
                  +011-43059315
                </p>

                {/* <p className="card-phone  d-flex align-items-center mb-2" >
                  <i className="fa fa-envelope me-2"></i>
                  ssmplasticdana@gmail.com
                </p> */}


    </div>

  </div>
</div>



          

          {/* Back Side */}
          <div className="card-face card-back">
            <div className="back-content">
              <h4 className="brand-title">Shree Ganesh Plastics</h4>
              <div className="brand-divider"></div>

              <h5 className="contact-heading">Contact Details</h5>

              <p className="address">
                <i className="fa fa-map-marker me-2"></i>
             Office Address: Plot No.   E-100-101, Sector-5, DSIIDC INDL Area, Bawana, Delhi-110039.
              </p>

              <p className="address">
                <i className="fa fa-industry me-2"></i>
                MFG Unit: Plot No. 54, Block E, Sector 5, DSIIDC
                Bawana, Delhi-110039.
              </p>

              <p className="address">
                <i className="fa fa-envelope me-2"></i>
                ssmplasticdana@gmail.com
              </p>
              <p className="address">
                <i className="fa fa-envelope me-2"></i>
                info@ppdana.com
              </p>

              <p className="address">
                <i className="fa fa-globe me-2"></i>
                ppdana.com
              </p>
            </div>
          </div>
        </div>
      </Tilt>

      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      <div className="action-buttons">
        <a href="/rajesh-gupta.vcf" download className="platinum-btn">
          Add To Contacts
        </a>

        <a href="tel:+919311280682" className="platinum-btn">
          Call Now
        </a>

        <a href="mailto:ssmplasticdana@gmail.com" className="platinum-btn">
          Email Us
        </a>

        <a
          href="https://wa.me/919311280682"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          WhatsApp
        </a>

        <a
          href="https://ppdana.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Website
        </a>

        <a
          href="https://maps.app.goo.gl/MYsHXSxcE9EFAb7j8"
          target="_blank"
          rel="noopener noreferrer"
          className="platinum-btn"
        >
          Address Details
        </a>
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
